import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../../components/shared';

interface BalancesSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const BalancesSearch: React.FC<BalancesSearchProps> = ({
  searchQuery,
  onSearchChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      <Input
        type="text"
        placeholder={t('billing.balances.searchPlaceholder')}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="w-full max-w-md"
      />
    </div>
  );
};

export default BalancesSearch;
